import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "flex items-center justify-center h-full"
}
const _hoisted_2 = { class: "flex flex-col gap-1 items-center text-center" }
const _hoisted_3 = { class: "text-sm" }

import { NoSymbolIcon } from "@heroicons/vue/24/outline";
import Highcharts from "highcharts";
import { Chart } from "highcharts-vue";
import { computed } from "vue";
import { useI18n } from "vue-i18n";


export default /*#__PURE__*/_defineComponent({
  __name: 'ChartOrNoData',
  props: {
    options: {},
    cls: {}
  },
  setup(__props: any) {

const props = __props;

const { t } = useI18n();

const hasData = computed(
  () =>
    props.options &&
    props.options.series &&
    props.options.series.length > 0 &&
    props.options.series.some((series) => "data" in series && series.data?.length),
);

return (_ctx: any,_cache: any) => {
  return (hasData.value)
    ? (_openBlock(), _createBlock(_unref(Chart), {
        key: 0,
        options: _ctx.options,
        class: _normalizeClass(_ctx.cls)
      }, null, 8, ["options", "class"]))
    : (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_unref(NoSymbolIcon), { class: "w-8 h-8" }),
          _createElementVNode("div", _hoisted_3, _toDisplayString(_unref(t)("analytics.reports.no_data_for_report")), 1)
        ])
      ]))
}
}

})